import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
// import { IntegrationService } from '../../integration.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { HelperService } from 'src/app/core/services/helper.service';
import { DataTable, SharedService } from '../../shared.service';
import { BaseService } from 'src/app/core/services/base.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-incoming-message-binaries-dialog',
  templateUrl: './incoming-message-binaries-dialog.component.html',
  styleUrls: ['./incoming-message-binaries-dialog.component.scss']
})
export class IncomingMessageBinariesDialogComponent implements OnInit {
  public dataTable: DataTable;
  public selectedIncomingMessageBinary: any;
  public textToDisplay: string;
  public titleToDisplay: string;

  constructor(
    // private api: IntegrationService,
    private notificationService: NotificationService,
    private clipboard: Clipboard,
    private helper: HelperService,
    private sharedService: SharedService,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: {
      incomingMessageId: number;
    }
  ) { }

  async ngOnInit(): Promise<void> {
    this.dataTable = (await this.sharedService.getDataTable('portal_integration_incoming_message_binary_table_config', 'portal_integration_incoming_message_binary_table_content', { incomingMessageId: this.data.incomingMessageId }));
  }

  downloadMessageResult(): void {
    if (this.selectedIncomingMessageBinary.messageFormat === "B") {
      var blob = this.base64ToBlob(this.getSelectedMessageResponseBinaryData(), 'text/plain');
      fileSaver.saveAs(blob, "file.data");
      return;
    }

    const element = document.createElement('a');
    switch (this.selectedIncomingMessageBinary.messageFormat) {
      case 'X':
        element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(this.getSelectedMessageResponseBinaryData()));
        element.setAttribute('download', 'payload' + '.xml');
        break;
      case 'J':
        element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(this.getSelectedMessageResponseBinaryData()));
        element.setAttribute('download', 'payload' + '.json');
        break;
      case 'T':
        element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(this.getSelectedMessageResponseBinaryData()));
        element.setAttribute('download', 'payload' + '.txt');
        break;
      default:
        this.notificationService.error(`Message format ${this.selectedIncomingMessageBinary.messageFormat} not supported`);
        // element.setAttribute('href', 'data:application/octet-stream,' + encodeURIComponent(this.helper.dataURItoString(this.getSelectedMessageResponseBinaryData())));
        // element.setAttribute('download', 'payload' + '.data');
        break;
    }

    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  copyMessageResult(): void {
    if (this.textToDisplay === null) {
      return;
    }
    this.notificationService.success('Copied to ClipBoard');
    this.clipboard.copy(this.getSelectedMessageResponseBinaryData());
  }

  getSelectedMessageResponseBinaryData(): string {
    return this.selectedIncomingMessageBinary.xmlData || this.selectedIncomingMessageBinary.jsonData || this.selectedIncomingMessageBinary.textData || this.selectedIncomingMessageBinary.binaryData
  }

  async actionButtonClicked(event: any) {
    if (event.actionCode === 'VIEW-MESSAGE-CONTENT') {
      this.titleToDisplay = event?.data?.dataUsage + ' - ' + event?.data?.incomingMessageId || 'Payload';
      let requestData = event.data;
      let resultBinary = (await this.baseService.executeCommand<any>('portal_integration_incoming_message_binary_retrieve', requestData).toPromise()).data;
      this.selectedIncomingMessageBinary = resultBinary;
      switch (resultBinary.messageFormat) {
        case 'X':
          this.textToDisplay = resultBinary.xmlData;
          break;
        case 'J':
          this.textToDisplay = resultBinary.jsonData;
          break;
        case 'T':
          this.textToDisplay = resultBinary.textData;
          break;

        default:
          this.textToDisplay = 'Binary file cannot be displayed.';
          break;
      }
    }
  }

  canCopyItem(item: any) {
    return item.messageFormat === 'X' || item.messageFormat === 'J' || item.messageFormat === 'T';
  }
}
